"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _definitionhelpers = require("../../../utils/definitionhelpers");
/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */

/* ++++++++++ --------------- BREAD CRUMB NAV : DEFINITION --------------- ++++++++++ */


var _default = {
  name: 'BreadCrumbNav',
  group: _definitionhelpers.groupNames.navs,
  props: {
    name: {
      type: 'string',
      default: 'breadcrumbnav'
    },
    currentPage: {
      type: 'string',
      default: 'home'
    },
    items: {
      type: 'array',
      default: [{
        name: 'manager',
        text: 'Question Manager',
        icon: 'list',
        type: 'internal',
        action: 'apps/classification/manager'
      }, {
        name: 'editor',
        text: 'Classification Editor',
        icon: 'edit',
        type: 'internal',
        action: 'apps/classification/editor'
      }]
    }
  }
};
exports.default = _default;